import { cva } from 'class-variance-authority';
export const buttonVariants = cva('', {
    variants: {
        variant: {
            default: 'btn-default',
            brand: 'btn-brand',
            primary: 'btn-primary',
            success: 'btn-success',
            warn: 'btn-warn',
            danger: 'btn-danger',
            base: 'btn-base',
            epic: 'btn-epic',
            alert: 'btn-alert',
        },
        strategy: {
            default: '',
            ghost: 'btn-ghost',
            outlined: 'btn-outlined',
            text: 'btn-text',
            quite: 'btn-quite',
            link: 'btn-link',
        },
        size: {
            small: 'btn-small',
            mini: 'btn-mini',
            large: 'btn-large',
            medium: 'btn-medium',
        },
    },
    defaultVariants: {
        variant: 'base',
        size: 'medium',
    },
});
//# sourceMappingURL=variants.js.map